// 通过promise或者await返回下面这种数据结构
// {
//     response: {}, // json格式的数据
//     status: 123, // 状态码
//     rawResponse: {} // 原始的响应对象，里面包含了所有的信息
// }

declare global {
    interface Window {
        globalData: {
            isServerEnv: boolean;
            apiPrefix: string;
        };
    }
}

import $ from 'jquery';
// 设置 Deviceid ------
// getGuid
function getGuid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

// setCookie
function setCookie(cname: string, cvalue: string, exdays: number) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    if (window.globalData.isServerEnv) {
        document.cookie = `${cname}=${cvalue}; ${expires}; domain=.lixiang.com; path=/`;
    } else {
        document.cookie = `${cname}=${cvalue}; ${expires}; path=/`;
    }
}

// 获取cookie
function getCookie(name: string) {
    if (document.cookie.length > 0) {
        let start = document.cookie.indexOf(`${name}=`);
        if (start !== -1) {
            start = start + name.length + 1;
            let end = document.cookie.indexOf(';', start);
            if (end === -1) {
                end = document.cookie.length;
            }
            return unescape(document.cookie.substring(start, end));
        }
    }
    return '';
}

// checkDeviceid
function checkDeviceid() {
    // X-LX-Deviceid
    const deviceid = getCookie('X-LX-Deviceid') || getGuid();
    // set deviceid
    setCookie('X-LX-Deviceid', deviceid, 365);
}

// 将错误响应和正确响应的格式统一
function refineErrorResponse(rawResponse: any) {
    const result = {
        response: rawResponse.responseJSON || {},
        status: rawResponse.status,
        rawResponse
    };
    console.log('接口错误：');
    console.log(result);
    return result;
}

function refineSuccessResponse(response: any, rawResponse: any) {
    const result = {
        response,
        status: rawResponse.status,
        rawResponse
    };
    // console.log('接口成功：');
    // console.log(result);
    return result;
}

function rawAjax(
    type: string,
    url: string,
    data: any,
    headers: any,
    success: any,
    error: any
) {
    $.ajax({
        // 如果是以/api/开头，表示是咱自己node提供的api，不需要加apigateway的前缀
        url:
            url.indexOf('http') === 0 || url.indexOf('/api/') === 0
                ? url
                : window.globalData.apiPrefix + url,
        type,
        data,
        timeout: 20000,
        xhrFields: {
            withCredentials: true
        },
        headers,
        dataType: 'json',
        crossDomain: true,
        contentType: 'application/json',
        success(response, statusText, rawResponse) {
            success(response, statusText, rawResponse);
        },
        error: rawResponse => {
            error(rawResponse);
        }
    });
}

// ajax错误回调
function errorCallback(
    type: string,
    url: string,
    data: any,
    headers: any,
    rawResponse: any,
    resolve: any,
    reject: any
) {
    // 在webview中跨域经常发生错误，如果发生错误则使用node中转接口
    if (rawResponse.status === 0) {
        console.log('网络错误');
        // 前缀删除后就使用node中转接口
        window.globalData.apiPrefix = '';
        rawAjax(
            type,
            url,
            data,
            headers,
            (response: any, statusText: any, innerRawResponse: any) => {
                resolve(refineSuccessResponse(response, innerRawResponse));
            },
            (innerRawResponse: any) => {
                reject(refineErrorResponse(innerRawResponse));
            }
        );
    } else {
        reject(refineErrorResponse(rawResponse));
    }
}

// ajax公用方法
function xajax(type: string, url: string, data: any, headers: any) {
    if (
        performance &&
        performance.navigation &&
        performance.navigation.type === 2
    ) {
        if (url.indexOf('?') > -1) {
            url += `&r=${new Date().getTime()}`;
        } else {
            url += `?r=${new Date().getTime()}`;
        }
    }

    // 添加设备id的cookie
    checkDeviceid();

    if (type === 'POST' || type === 'PUT') {
        data = JSON.stringify(data);
    }

    return new Promise<{ response: any; status: number; rawResponse: any }>(
        (resolve, reject) => {
            rawAjax(
                type,
                url,
                data,
                headers,
                (response: any, statusText: number, rawResponse: any) => {
                    resolve(refineSuccessResponse(response, rawResponse));
                },
                (rawResponse: any) => {
                    errorCallback(
                        type,
                        url,
                        data,
                        headers,
                        rawResponse,
                        resolve,
                        reject
                    );
                }
            );
        }
    );
}

const result: { [index: string]: any } = {
    get(url: string, data?: any, headers?: any) {
        return xajax('GET', url, data, headers);
    },
    post(url: string, data?: any, headers?: any) {
        return xajax('POST', url, data, headers);
    },
    put(url: string, data?: any, headers?: any) {
        return xajax('PUT', url, data, headers);
    },
    delete(url: string, data?: any, headers?: any) {
        return xajax('DELETE', url, data, headers);
    }
};
export default result;
